import { Component, ElementRef, inject, OnDestroy, DOCUMENT, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OpenClose, routeAnimation } from './shared/animations';
import { TrapFocusDirective } from '@app/shared/directives';

@Component({
    selector: 'app-menu-admin',
    templateUrl: './menu-admin.component.html',
    styleUrls: ['./menu-admin.component.css'],
    imports: [RouterModule],
    animations: [OpenClose, routeAnimation],
    hostDirectives: [TrapFocusDirective],
    host: {
        '[@OpenClose]': 'true',
        role: 'dialog',
        'aria-modal': 'true',
        '[attr.aria-label]': "this.translateService.instant('admin-menu.aria-label')",
        tabindex: '-1',
        '(document:keydown.escape)': 'onKeydownHandler()',
        '(click)': 'onHostClick($event)',
    },
})
export class MenuAdminComponent implements OnDestroy, AfterViewInit {
    private elementRef = inject(ElementRef);
    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);
    private document = inject(DOCUMENT);

    readonly translateService = inject(TranslateService);

    private previousActiveElement: HTMLElement | null = <HTMLElement>this.document.activeElement;

    ngAfterViewInit(): void {
        this.elementRef.nativeElement.focus();
    }

    ngOnDestroy(): void {
        this.previousActiveElement?.focus();
    }

    onKeydownHandler(): void {
        this.close();
    }

    onHostClick(e: MouseEvent): void {
        if (this.elementRef.nativeElement === e.target) {
            this.close();
        }
    }

    private close() {
        this.router.navigate(['..'], { relativeTo: this.activatedRoute });
    }
}
